import { createSlice } from "@reduxjs/toolkit";

const initialEducationTerm = {
  firstSemesterStart: "",
  firstSemesterEnd: "",
  secondSemesterStart: "",
  secondSemesterEnd: "",
  thirdSemesterStart: "",
  thirdSemesterEnd: "",
  fourthSemesterStart: "",
  fourthSemesterEnd: "",
  isActive: true,
};

const initialEducationTermsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  semesterCount: 0,
  educationTerm: initialEducationTerm
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const educationTermSlice = createSlice({
  name: "educationTerms",
  initialState: initialEducationTermsState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getEducationTerms
    educationTermsFetched: (state, action) => {
      const { isSuccess, type, totalCount, entity, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;      
      state.semesterCount = entity && entity.semesterCount;
    },
    //getEducationTerm
    educationTermFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.educationTerm = action.payload.entity;
    },
    // completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanEducationTermsState
    educationTermsStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = [];
      state.educationTerm = initialEducationTerm;
    }
  }
});